import type { OptimizerQueryState } from "./query-state";
import type { PlatformType } from "./utils-v2";
import { SPORTSBOOK_SURFACE, getSportsbookSurfacePolicy } from "@/lib/sportsbook-preferences";

const OPTIMIZER_POLICY = getSportsbookSurfacePolicy(SPORTSBOOK_SURFACE.OPTIMIZER);

export const OPTIMIZER_BOOKS: PlatformType[] = [...OPTIMIZER_POLICY.supportedBookIds];

const OPTIMIZER_BOOK_SET = new Set<PlatformType>(OPTIMIZER_BOOKS);

export const DEFAULT_OPTIMIZER_BOOK: PlatformType = OPTIMIZER_POLICY.preferredBookIds[0] ?? OPTIMIZER_BOOKS[0];

export function ensureOptimizerBook(book?: string | null): PlatformType {
  const normalized = (book ?? "").toLowerCase() as PlatformType;
  return OPTIMIZER_BOOK_SET.has(normalized) ? normalized : DEFAULT_OPTIMIZER_BOOK;
}

export function clampOptimizerState(state: OptimizerQueryState): OptimizerQueryState {
  const normalized = ensureOptimizerBook(state.platform);
  if (normalized === state.platform && normalized === state.sportsbook) return state;
  return { ...state, sportsbook: normalized, platform: normalized };
}
